import { c as _c } from "react/compiler-runtime";
import { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from "react";
interface ContextShape {
  ids: Set<string>;
  setAllIds: (ids: string[]) => void;
  toggle: (id: string) => void;
}

/**
 * Creates a React Context with its hook which contains a list of subscribed newsletters IDs.
 * The context also provides a function to toggle a newsletter ID.
 */
const createNewsletterContext = () => {
  const Context = createContext<ContextShape>({
    ids: new Set(),
    setAllIds: () => {},
    toggle: () => {}
  });
  const Provider = t0 => {
    "use memo";

    const $ = _c(10);
    const {
      children
    } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = new Set();
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    const [ids, setIds] = useState(t1);
    let t2;
    if ($[1] !== ids) {
      t2 = id => {
        ids.has(id) ? ids.delete(id) : ids.add(id);
        setIds(new Set(ids));
      };
      $[1] = ids;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const toggle = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = newsletterIds => setIds(new Set(newsletterIds));
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    const setAllIds = t3;
    let t4;
    if ($[4] !== ids || $[5] !== toggle) {
      t4 = {
        ids,
        setAllIds,
        toggle
      };
      $[4] = ids;
      $[5] = toggle;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const contextValue = t4;
    let t5;
    if ($[7] !== children || $[8] !== contextValue) {
      t5 = <Context.Provider value={contextValue}>{children}</Context.Provider>;
      $[7] = children;
      $[8] = contextValue;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  };
  const useContextValue = () => useContext(Context);
  return {
    Provider,
    useContextValue
  };
};
export const {
  Provider: SubscribedNewslettersContext,
  useContextValue: useSubscribedNewslettersContext
} = createNewsletterContext();
export const {
  Provider: SelectedNewslettersContext,
  useContextValue: useSelectedNewslettersContext
} = createNewsletterContext();